import { hotBoard } from "@/mocks/media";

const rankColors = ["bg-primary-500", "bg-accent-500", "bg-secondary-500"];

export default function HotBoard() {
  return (
    <section id="hot" className="scroll-mt-20 py-12 md:py-16 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
          <div>
            <p className="text-xs font-semibold tracking-[0.3em] text-primary-600">HOT BOARD</p>
            <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950">今日吃瓜热榜</h2>
          </div>
          <p className="text-sm text-foreground-500">按当前关注度滚动更新 · 观点不代表51影院立场</p>
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-x-8 gap-y-4">
          {hotBoard.map((item, i) => (
            <a
              key={i}
              href="#hot"
              className="group flex items-center gap-4 p-3 rounded-lg hover:bg-background-100"
            >
              <span
                className={`w-8 h-8 shrink-0 rounded-md flex items-center justify-center text-sm font-bold text-background-50 ${
                  rankColors[i] ?? "bg-background-300 text-foreground-600"
                }`}
              >
                {i + 1}
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 leading-snug group-hover:text-primary-600">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-400 flex items-center gap-3">
                  <span className="text-primary-600 font-medium">#{item.tag}</span>
                  <span>{item.time}</span>
                </p>
              </div>
              <span className="shrink-0 text-xs text-accent-600 font-semibold whitespace-nowrap">
                {item.hot} 热度
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}